// AUTO GENERATED FROM ../Resources/_SourceFiles/Common.en-US.txt
/* eslint 'no-template-curly-in-string': 'off','no-dupe-keys': 'off','no-useless-escape': 'off' */
export let resourceData = {
"optimalstart.Text":"* Occupied event with optimal start",
"AM_Text.Text":"AM",
"ApplyNewvalues.NotMoreThan2.Text":"Error: The value(s) you requested for Setpoints below will not be saved. The Cooling Setpoint must be at least 2 °F (1.1 °C) higher than the Heating Setpoint.",
"April_Text.Text":"April",
"PointStatus.PointName.Text":"Point Name",
"Atleast_One_Checkbox_Selected_Text.Text":"At least one checkbox must be checked!",
"AttributeDuplicate.Text":"Error: The wizard can’t proceed because an attribute with the name you entered below already exists. Click Back to see the names of existing attributes or type a unique attribute name and click Next.",
"August_Text.Text":"August",
"August_Abbreviated_Text.Text":"Aug",
"AutoLogOff.Text":"Your session is about to expire in",
"AutoLogOffExtendText.Text":"Click 'Extend Session' to remain logged into Tracer Ensemble.",
"BackButton.Text":"< Back",
"RetryButton.Text":"Retry",
"BacktoActionSetting.Text":"< Actions and Settings",
"BacktoBuildingAlarms.Text":"< Building Alarms",
"BitStringPrefix.Text":"a BitString(hex):",
"BuildingList.Address.Text":"Address",
"BuildingList.btnApplyFilter.Text":"Apply Filter",
"buildingList.btnChangeSchedule.Text":"Change Schedules",
"buildingList.btnDelete.Text":"Delete",
"buildingList.btnModifyProfile.Text":"Modify Profile",
"buildingList.btnRouteAlarms.Text":"Route Alarms",
"buildingList.btnViewAlarms.Text":"View Alarms",
"buildingList.btnViewDataLogs.Text":"View Data Logs",
"buildingList.btnViewSchedules.Text":"View Schedules",
"BuildingList.City.Text":"City",
"BuildingList.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"BuildingList.lblConfirmationDeleteMessage.Text":"You are about to permanently delete  (n) building(s). All data related to these buildings will be lost including Alarms, Data Logs, and Schedules. Once deleted, buildings can only be recovered by Adding New Buildings. Click OK to delete these buildings or Cancel to keep these buildings in the system and return to the Building List page.",
"BuildingList.lblForColumn.Text":"For Column",
"buildingList.lblMultipleBuildings.Text":"Multiple Buildings",
"BuildingList.lblShowOnly.Text":"Show Only",
"buildingList.lblSingleBuilding.Text":"Selected Building",
"BuildingList.lblUserAsstAdmin.Text":"To show only selected data, set up For column and Show only. Click Apply Filter.",
"BuildingList.lblUserAsstMessage.Text":"Click a column head to sort. Click to select one or more buildings. Click the appropriate multiple or single building operation.",
"BuildingList.PageSize.Text":"25",
"BuildingList.Sitename.Text":"Name",
"BuildingList.State.Text":"State",
"BuildingList.txtShowOnly.Text":"Show Only",
"BuildingList.Type.Text":"Type",
"BUILDINGS.Text":"Building List",
"BuildingList.ManageSchedules.Text":"Manage Schedules",
"BuildingList.EmergencySchedule.Text":"Emergency Schedules",
"BuildingList.btnAdvancedOptions.Text":"Advanced Options",
"CalendarText.Text":"Calendar",
"TenantPanelLicenseLimit.Text":"Tenant license reaches the limit.",
"CheckEmpty1.Text":"Error: You did not select any items.  Select items before you click an action button.",
"CheckEmpty2.Text":"Error: You did not select any items. Select items before you click Next or Finish.",
"CheckEmpty3.Text":"Error: You did not select any items.  Select items before you click an action button.",
"CheckEmpty4.Text":"Error: You did not select any items.  Select items before you click any action button.",
"CheckedMore.Text":"Error: You selected more than one item. Select only one item before you click this action button.",
"CheckEmptyForRadioButtons.Text":"Error: Nothing happened because there are no items selected in the list. Select items in the list by clicking their radio buttons and then click the button to act on only those items.",
"CheckMultipleItems.Text":"Nothing happened because you have selected multiple items in the list. Select single items and then click the button.",
"CheckEditableItems.Text":"Nothing happened because you have selected non editable items in the list. Select single editable item and then click the button.",
"CheckedAdvancedOverrideItems.Text":"Nothing happened because you do not have permission to override the selected point",
"Comma_Text.Text":",",
"Comparison_Text.Text":"comparison text",
"CONNECTING.Text":"CONNECTING",
"Customization.btnCloseWindow.Text":"No - Close Window",
"CustomPageLink.CustomizeSystemPage.Text":"Customize System Pages",
"Date_Separator_Text.Text":"/",
"Day_Text.Text":"Day",
"Days_Text.Text":"Days",
"December_Text.Text":"December",
"December_Abbreviated_Text.Text":"Dec",
"DISCOVERING.Text":"DISCOVERING",
"DISCOVERY_COMMUNICATION_FAILED.Text":"Failed, Not Communicating",
"DISCOVERY_COMPLETE.Text":"Complete",
"DISCOVERY_IN_PROGRESS.Text":"Panels being loaded...",
"DISCOVERY_IN_PROGRESS_FAILED.Text":"Failed, Started and Interrupted",
"DISCOVERY_NOT_STARTED.Text":"Waiting to Begin",
"EnumBuildingList.cboShowOnly.Text":"0",
"EnumBuildingList.cboShowOnly.0.Text":"No filter,view all",
"EnumSearchResult.cboShowOnly.Text":"0",
"EnumSearchResult.cboShowOnly.0.Text":"No filter,view all",
"Error.Text":"Error:",
"Error.Mark.Text":"!",
"InCorrectPassword.Text":"Error: You left necessary fields blank or entered invalid values.  Review and correct any fields with \"!\" next to them.",
"ErrorMoreThanTwoOnOff.Text":"Error: The wizard can't proceed because there are one or more days below that have more than two On or two Off events defined. Correct the marked times below to ensure that each day does not exceed the maximum allowed two On and Two Off events and click Next.",
"ErrorPage.TitleHeader.Text":"Application Error",
"ErrorPage.TitleHeader.PageNotFound.Text":"Page Not Available",
"ErrorPage.TitleHeader.BuildingNotFound.Text":"Building Not Found",
"ErrorPage.MyHome.Text":"My Home",
"ErrorPage.TESHome.Text":"Tracer Ensemble Home",
"ErrorPage.UserAssistance.Text":"You can go to any portion of the site by using the links at the top of the page, or by selecting one of the following links.",
"ErrorPage.Unknown.Text":"An error has occurred.  Please click the Back button in your browser and re-attempt your action.",
"ErrorPage.UserNotAuthorized.Text":"This page is not available based upon your user permissions.  Contact your system administrator if you should have access to this page.",
"ErrorPage.BuildingNotFound.Text":"The building you requested could not be found or you do not have sufficient permissions to view this page.",
"ErrorPage.UnitControllerNotFound.Text":"The requested unit controller was not found or you do not have sufficient permissions to view this unit controller.",
"ErrorPage.ApplicationOffline.Text":"The Tracer Ensemble component is offline or not responding.  Tracer Ensemble may not be running.  Contact your Tracer Ensemble Server Administrator.",
"ErrorPage.FileNotFound.Text":"The requested page was not found. Either it was deleted or you have insufficient permission to view the page.",
"Every_Text.Text":"Every",
"FAILURE.Text":"Failed",
"February_Text.Text":"February",
"February_Abbreviated_Text.Text":"Feb",
"FieldMissing1.Text":"Error: Nothing happened because there are no changes indicated in any of the text fields below. Indicate your desired changes in one or more for the fields below and click Apply New Values.",
"FieldMissing2.Text":"Error: You left necessary fields blank or entered invalid values.  Review and correct any fields with \"!\" next to them.",
"FieldMissing3.Text":"Error: You left necessary fields blank or entered invalid values.  Review and correct the field with \"!\" next to it.  Invalid values include <, >, &, ‘ and “.",
"FieldMissing4.Text":"Error: Review and correct any fields with \"!\" next to them.",
"FieldMissing5.Text":"An entry is required",
"HttpsValidation.Text":"URL must contain HTTPS",
"CertificateValidation.Text":"A valid certificate is required",
"FieldIsInPast.Text":"Error: Schedule Event was not created because all occurrences are in the past.",
"FieldFileFormat.Text":"Error: Certificate should be in .pfx format.",
"Filter_Date_option_Last_1_day.Text":"Last 1 Day",
"Filter_Date_option_Last_1_Hour.Text":"Last 1 Hour",
"Filter_Date_option_Last_1_Month.Text":"Last 1 Month",
"Filter_Date_option_Last_1_Week.Text":"Last 1 Week",
"Filter_Date_option_Last_12_Month.Text":"Last 12 Months",
"Filter_Date_option_Last_15_Mins.Text":"Last Fifteen Minutes",
"Filter_Date_option_Last_18_Month.Text":"Last 18 Months",
"Filter_Date_option_Last_18_Month_Ago.Text":"More than 18 months ago",
"Filter_Date_option_Last_2_days.Text":"Last 2 Days",
"Filter_Date_option_Last_2_Week.Text":"Last 2 Weeks",
"Filter_Date_option_Last_3_days.Text":"Last 3 Days",
"Filter_Date_option_Last_3_Month.Text":"Last 3 Months",
"Filter_Date_option_Last_4_Hours.Text":"Last 4 Hours",
"Filter_Date_option_Last_5_Mins.Text":"Last Five Minutes",
"Filter_Date_option_Last_6_Month.Text":"Last 6 Months",
"Filter_Date_option_Next_1_Month.Text":"Next 1 Month",
"Filter_Date_option_Next_12_Month.Text":"Next 12 Months",
"Filter_Date_option_Next_18_Month.Text":"Next 18 Months",
"Filter_Date_option_Next_18_Month_From_Now.Text":"More than 18 months from now",
"Filter_Date_option_Next_3_Month.Text":"Next 3 Months",
"Filter_Date_option_Next_6_Month.Text":"Next 6 Months",
"Filter_Date_option_Today.Text":"Today",
"FilterDefaultText.Text":"No filter, view all",
"footer.copyright.Text":"© 2026 Trane",
"footer.lblversion.Text":"Version",
"footer.Servicepack.Text":"Service Pack",
"footer.PrivacyPolicy.Text":"Privacy Policy",
"footer.TermsOfUse.Text":"Terms of Use",
"Friday_Text.Text":"Friday",
"GeneralValidationError.Text":"There are errors in the values you entered. Please correct the marked items below.",
"GoButtonAltText.Text":"Go",
"header.Administration.Text":"Administration",
"header.ChangePassword.Text":"Change Password",
"header.EnterpriseAlarms.Text":"All Alarms",
"header.AlarmToolTip.Text":"New alarms have arrived",
"header.Help.Text":"Tracer™ Ensemble Help",
"header.ProcessTracker.Text":"Process Tracker",
"header.Logout.Text":"Log Out",
"header.ActionsSettings.Text":"Actions and Settings",
"header.MyHome.Text":"My Home",
"header.Reports.Text":"Reports",
"header.Reports.StandardReport.Text":"Run Standard Reports",
"header.Reports.CustomReport.Text":"Manage Reports",
"header.Reports.SavedReport.Text":"Completed Reports",
"header.Dashboards.Text":"Dashboards",
"header.Preferences.Text":"General Preferences",
"header.AlarmPreferences.Text":"Alarm Preferences",
"header.AllBuildings.Text":"All Buildings",
"header.Tenant.Text":"Tenant Services",
"header.WorkOrder.Text":"Work Order Management",
"header.DashboardsAndReports.Text":"Dashboards & Reports",
"header.FacilitiesManagement.Text":"Facilities Management",
"header.BillingInvoices.Text":"Invoices",
"header.lbldbdescription.Text":"Create your own visual display of current system health/performance, along with history, for more insight into problems or better system understanding.",
"header.lblrptdescription.Text":"Generate reports to showcase data from your buildings.",
"header.lblTenantdescription.Text":"Manage after-hours requests, invoices, and more.",
"header.lblWOdescription.Text":"Schedule, prioritize, and track work orders and preventative maintenance.",
"header.lblLearnMore.Text":"Learn more",
"header.lblBuy.Text":"Buy",
"header.TracerHelp.Text":"Tracer Ensemble Help",
"header.TraneEducationCenter.Text":"Trane Education Center",
"header.EnsembleVideos.Text":"Ensemble  Help Videos",
"help.Text":"Help",
"HelpText.Text":"Help",
"HomePageLink.Text":"My Home",
"Hour_Text.Text":"Hour",
"Hours_Text.Text":"Hours",
"Indentation_Text.Text":">",
"ipAddressValidationPat.Text":"/^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}$/",
"January_Text.Text":"January",
"January_Abbreviated_Text.Text":"Jan",
"July_Text.Text":"July",
"July_Abbreviated_Text.Text":"Jul",
"June_Text.Text":"June",
"June_Abbreviated_Text.Text":"Jun",
"Last_1_Day.Text":"Last 1 Day",
"Last_1_Hour.Text":"Last 1 Hour",
"Last_1_Month.Text":"Last 1 Month",
"Last_1_Week.Text":"Last 1 Week",
"Last_10_Years.Text":"Last 10 Years",
"Last_12_Months.Text":"Last 12 Months",
"Last_18_Months.Text":"Last 18 Months",
"Last_2_Days.Text":"Last 2 Days",
"Last_2_Weeks.Text":"Last 2 Weeks",
"Last_2_Years.Text":"Last 2 Years",
"Last_3_Days.Text":"Last 3 Days",
"Last_3_Months.Text":"Last 3 Months",
"Last_3_Years.Text":"Last 3 Years",
"Last_4_Hours.Text":"Last 4 Hours",
"Last_5_Years.Text":"Last 5 Years",
"Last_6_Months.Text":"Last 6 Months",
"Last_7_Years.Text":"Last 7 Years",
"Last_Fifteen_Minutes.Text":"Last Fifteen Minutes",
"Last_Five_Minutes.Text":"Last Five Minutes",
"lblAdmin.Text":"Administration",
"lblPreferences.Text":"Preferences",
"March_Text.Text":"March",
"March_Abbreviated_Text.Text":"Mar",
"Max_Five_DataLogs_Selected_Text.Text":"Maximum five DataLogs can be selected!",
"May_Text.Text":"May",
"May_Abbreviated_Text.Text":"May",
"Midnight_Text.Text":"Midnight",
"Minute_Text.Text":"Minute",
"Minutes_Text.Text":"Minutes",
"mnuAlarmActions.Text":"Alarm Actions",
"mnuMessageTemplates.Text":"Message Templates",
"mnuCategories.Text":"Categories",
"mnuEmailAddress.Text":"Email Address",
"mnuIgnoredAlarms.Text":"Ignored Alarms",
"mnuEmergency.Text":"Emergency Schedules",
"mnuScheduleTemplates.Text":"Templates",
"mnuAllBuildingSchedules.Text":"Global Schedules",
"mnuUserAdministation.Text":"User Administration",
"mnuUser.Text":"User",
"mnuRoles.Text":"Roles",
"mnuUserChangeLog.Text":"User Change Log",
"mnuTenantServices.Text":"Tenant Services",
"mnuWorkOrder.Text":"Work Order Services",
"mnuReports.Text":"Reports",
"mnuCompletedReports.Text":"Completed Reports",
"mnuBuildingIndex.Text":"Building Index",
"mnuSystemStatus.Text":"System Status",
"mnuDashboards.Text":"Dashboards",
"mnuAdvanced.Text":"Advanced",
"mnuAirHandler.Text":"Air Handler",
"mnuAlarms.Text":"Alarms",
"mnuNoAlarms.Text":"No Alarms",
"mnuAttributes.Text":"Attributes",
"mnuVirtualBuildings.Text":"Virtual Buildings",
"mnuSetPointsOverrides.Text":"Setpoints & Overrides",
"mnuAlarmConfiguration.Text":"Configure Properties",
"mnuBuilding.Text":"Building",
"mnuChillerPlant.Text":"Chiller Plant",
"mnuChillers.Text":"Chiller",
"mnuDataLogs.Text":"Data Logs",
"mnuEquipment.Text":"Equipment",
"mnuHeatPumpLoop.Text":"Heat Pump Loop",
"mnuInputOutput.Text":"Points",
"mnuMapPanel.Text":"Map Panel",
"mnuMapPriorities.Text":"Map Priorities",
"mnuProgrammable.Text":"Programmable",
"mnuRouteEmails.Text":"Set Up Alarm Actions",
"mnuSchedules.Text":"Schedules",
"mnuNormalSchedules.Text":"Normal",
"mnuExceptions.Text":"Exceptions",
"mnuCalendars.Text":"Calendars",
"mnuSiteSync.Text":"Device Updates",
"mnuSpaces.Text":"Spaces",
"mnuSubSystems.Text":"Systems",
"mnuSummary.Text":"Summary",
"mnuSystemEvents.Text":"System Tasks",
"mnuTemplates.Text":"Templates",
"mnuVariableAir.Text":"Variable Air",
"mnuViewPanel.Text":"View Panel",
"mnuResetPanel.Text":"Panel Utilities",
"mnuDevicesList.Text":"Devices",
"mnuBACnetViewer.Text":"BACnet Viewer",
"mnuHubParameters.Text":"Hub Parameters",
"mnuTreeEditor.Text":"Tree Editor",
"mnuBACnetExplorer.Text":"BACnet Explorer",
"mnuBACnetPhoneBook.Text":"BCU Phone Book",
"mnuBACnetSimulator.Text":"BACnet Simulator",
"mnuCustomizeSite.Text":"Customize Site",
"mnuCustomGraphics.Text":"Custom Graphics",
"mnuAssignGraphics.Text":"Assign Graphics",
"mnuBuildingIndexSetup.Text":"Building Index Setup",
"mnuStatusPageData.Text":"Status Page Data",
"mnuMeter.Text":"Meters",
"mnuEventMarkers.Text":"Event Markers",
"Monday_Text.Text":"Monday",
"More_Than_A_Week_From_Today.Text":"More than a week from today",
"MyHome.Text":"My Home",
"No_Text.Text":"No",
"None.Text":"---",
"None_Text.Text":"None",
"NoRecords.Text":"No Records Found",
"SqlErrorTimeOut.Text":"Database is currently processing a large amount of data. Please check back later.",
"CreateTenant.NoRecords.Text":"Add subgroups to this building to use tenant services. See Tracer Ensemble Help for more information.",
"NOT_CONNECTED.Text":"NOT_CONNECTED",
"NOT_DISCOVERED.Text":"NOT DISCOVERED",
"NOT_OPERATIONAL.Text":"NOT OPERATIONAL",
"November_Text.Text":"November",
"November_Abbreviated_Text.Text":"Nov",
"October_Text.Text":"October",
"October_Abbreviated_Text.Text":"Oct",
"Off.Text":"Off",
"On.Text":"On",
"OPERATIONAL.Text":"OPERATIONAL",
"Page_Not_Available.Text":"Page Not Available",
"Password.DupPassword.Text":"Error: The new password you chose is the same as your current password. Your new password must be different than your current password.",
"Password.DupUidPwd.Text":"Error: The New Password entered is a risk to security because it is the same as, or contains, the User ID. Please create a new password that does not contain the User ID.",
"Password.IncorrectOldPWD.Text":"Error: Your current password is incorrect. Please enter your current password and your new password twice in the fields below.",
"Password.NewConfirm.Text":"Error: The Confirm New Password text entered does not match the New Password text. To create a new password, please enter the same text in both fields.",
"Password.PolicyRequirements.Text":"Error: The new password you chose does not meet the password policy requirements set by the System Administrator.  Contact your System Administrator for further details.",
"PM_Text.Text":"PM",
"Print.btnCloseWindow.Text":"Close Window",
"Print.btnPrint.Text":"Print",
"ProductHomePageLink.Text":"Tracer Ensemble Home",
"READY_TO_PERFORM_FIRST_SYNC.Text":"READY TO PERFORM FIRST SYNC",
"Sample_Text.Text":"Samples",
"Saturday_Text.Text":"Saturday",
"ScheduleDuplicate.Text":"The wizard can't proceed because you changed the Temporary Schedule Name to one that has already been used. Click Back to Manage All Temporary Schedules to view the existing Temporary Schedule Names, change the name back to the original, or type in a unique name and click Next.",
"SearchResult.Address.Text":"Address",
"SearchResult.btnApplyFilter.Text":"Apply Filter",
"SearchResult.btnChangeSchedules.Text":"Change Schedules",
"SearchResult.btnDelete.Text":"Delete",
"SearchResult.btnModifyProfiles.Text":"Modify Profile",
"SearchResult.btnRouteAlarms.Text":"Route Alarms",
"SearchResult.btnViewAlarms.Text":"View Alarms",
"SearchResult.btnViewDatalogs.Text":"View Data Logs",
"SearchResult.btnViewSchedule.Text":"View Schedules",
"SearchResult.btnEditSetPoints.Text":"Edit Setpoints",
"SearchResult.btnChangeSchedule.Text":"Change Schedules",
"SearchResult.btnSetOverride.Text":"Set Override",
"SearchResult.btnCreateGlobalReference.Text":"Create Global Reference",
"SearchResult.btnSyncDatabase.Text":"Synchronize Database",
"SearchResult.btnSyncTime.Text":"Synchronize Time",
"SearchResult.btnEditBuildingAttributes.Text":"Edit Attributes",
"SearchResult.BuildingName.Text":"Building Name",
"SearchResult.AddrCountry.Text":"Country",
"SearchResult.TimeZone.Text":"Time Zone",
"SearchResult.SiteType.Text":"Type",
"SearchResult.PortNumber.Text":"Port",
"SearchResult.AddrPostalCode.Text":"Postal Code",
"SearchResult.City.Text":"City",
"SearchResult.EmergencySchedule.Text":"Emergency Schedule",
"SearchResult.lblForColumn.Text":"For Column",
"SearchResult.lblGoText.Text":"Error: Some text in the field below is required in order to look for matching buildings.",
"SearchResult.lblMultipleBuildings.Text":"Multiple Buildings",
"SearchResult.lblShowOnly.Text":"Show Only",
"SearchResult.lblSingleBuilding.Text":"Selected Building",
"SearchResult.lblUserAsstAdmin.Text":"To show only selected data, set up For column and Show only. Click Apply Filter.",
"SearchResult.lblUserAsstMessage.Text":"Click links under Name for details or select one or more rows and click an action button on the right.",
"SearchResult.lbtnPrinterFriendly.Text":"View Printer-Friendly Page",
"SearchResult.PageSize.Text":"25",
"SearchResult.search.Text":"Search Results",
"SearchResult.SearchResults.Text":"Search Results for",
"SearchResult.State.Text":"State",
"SearchResult.txtShowOnly.Text":"Show Only",
"SearchResult.btnActivate.Text":"Activate Emergency Schedule",
"SearchResult.btnDeactivate.Text":"Deactivate Emergency Schedule",
"SearchResult.btnEmergencyScheduleConfiguration.Text":"Emergency Schedule Configuration",
"SearchResult.ButtonGlobal.Text":"Global Changes",
"SearchResult.ButtonAdv.Text":"Advanced",
"SearchResult.SchdlLabel.Text":"Selected Buildings",
"StatusEditControl.DefaultDropdownElement.Text":"",
"EnumSearchResults.cboForColumn.0.Text":"No Filter, view all",
"EnumSearchResults.cboForColumn.1.Text":"Building Name",
"EnumSearchResults.cboForColumn.2.Text":"City",
"EnumSearchResults.cboForColumn.3.Text":"State",
"EnumSearchResults.cboForColumn.4.Text":"Emergency Schedule",
"EnumSearchResults.cboForColumn.Text":"0,1,2,3,4",
"September_Text.Text":"September",
"September_Abbreviated_Text.Text":"Sep",
"Short_Friday_Text.Text":"Fri",
"Short_Monday_Text.Text":"Mon",
"Short_Saturday_Text.Text":"Sat",
"Short_Sunday_Text.Text":"Sun",
"Short_Thursday_Text.Text":"Thu",
"Short_Tuesday_Text.Text":"Tue",
"Short_Wednesday_Text.Text":"Wed",
"Shortest_Friday_Text.Text":"Fr",
"Shortest_Monday_Text.Text":"Mo",
"Shortest_Saturday_Text.Text":"Sa",
"Shortest_Sunday_Text.Text":"Su",
"Shortest_Thursday_Text.Text":"Th",
"Shortest_Tuesday_Text.Text":"Tu",
"Shortest_Wednesday_Text.Text":"We",
"SHUTDOWN.Text":"SHUTDOWN",
"SHUTTING_DOWN.Text":"SHUTTING_DOWN",
"SI_UnitSystem_Text.Text":"SI",
"STARTUP.Text":"STARTUP",
"Subheader.FindBuildings.Text":"Find Buildings",
"Subheader.LoggedAs.Text":"You are logged in as",
"Subheader.SearchTips.Text":"Search Tips",
"subheader.RecentVisits.Text":"Recent Visits",
"Subheader.ErrorMessage.Text":"Error: Some text in the field below is required in order to look for matching buildings.",
"SUCCESS.Text":"Successful",
"Sunday_Text.Text":"Sunday",
"SYNCHRONIZING.Text":"SYNCHRONIZING",
"SystemBooleanFalse.Text":"No",
"SystemBooleanTrue.Text":"Yes",
"TESHome.Text":"TES Home",
"Thursday_Text.Text":"Thursday",
"To_Text.Text":"to",
"Today_Text.Text":"Today",
"ToolTipText.Text":"Sort column by",
"Tracer.Text":"Tracer Ensemble",
"Tuesday_Text.Text":"Tuesday",
"Type_Text.Text":"Type",
"UNSYNCHRONIZED.Text":"UNSYNCHRONIZED",
"validationPattern.Text":"*|,\\\":&;[]{}`\\'()@$#%",
"ViewPntFriendlyPage.Text":"View Printer-Friendly Page",
"Wednesday_Text.Text":"Wednesday",
"WithIn_The_Next_24_Hours.Text":"Within the next 24 hours",
"WithIn_The_Next_3_Days.Text":"Within the next 3 days",
"WithIn_The_Next_Week.Text":"Within the next week",
"Yes_Text.Text":"Yes",
"Yesterday_Text.Text":"Yesterday",
"GridPageDisplay.Text":"Items {0} to {1} of {2}",
"ErrorPage.Title.Text":"Error",
"ErrorPage.PageNotFound.Title.Text":"Page Not Available",
"ErrorPage.BuildingNotFound.Title.Text":"Building Not Found",
"DataGrid.More.Text":"More..",
"DataGrid.First.Text":"<< First",
"DataGrid.Last.Text":"Last >>",
"DataGrid.Next.Text":"Next >",
"DataGrid.Previous.Text":"< Previous",
"Unknown.TitleHeader.Text":"--Insert Title--",
"Unknown.UserAssistance.Text":"--Insert User Assistance--",
"mnuArea.Text":"Area",
"mnuAirSystems.Text":"Air Systems",
"mnuTrimRespond.Text":"Trim/Respond",
"Noon.Text":"Noon",
"EndOfDay.Text":"End of Day",
"RequestedOperationFalied.Text":"Error! The requested operation falied.",
"WeatherService.Header.Text":"Local Conditions",
"EnumGMTShort.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34",
"EnumGMTShort.0.Text":"None",
"EnumGMTShort.1.Text":"DST",
"EnumGMTShort.2.Text":"SST",
"EnumGMTShort.3.Text":"HAST",
"EnumGMTShort.4.Text":"AKST",
"EnumGMTShort.5.Text":"PST",
"EnumGMTShort.6.Text":"MST",
"EnumGMTShort.7.Text":"CST",
"EnumGMTShort.8.Text":"EST",
"EnumGMTShort.9.Text":"VST",
"EnumGMTShort.10.Text":"AST",
"EnumGMTShort.11.Text":"NST",
"EnumGMTShort.12.Text":"ESAST",
"EnumGMTShort.13.Text":"MAST",
"EnumGMTShort.14.Text":"CVST",
"EnumGMTShort.15.Text":"WET",
"EnumGMTShort.16.Text":"CET",
"EnumGMTShort.17.Text":"EET",
"EnumGMTShort.18.Text":"MSK",
"EnumGMTShort.19.Text":"CST",
"EnumGMTShort.20.Text":"KST",
"EnumGMTShort.21.Text":"IST",
"EnumGMTShort.22.Text":"IST",
"EnumGMTShort.23.Text":"KST",
"EnumGMTShort.24.Text":"ADST",
"EnumGMTShort.25.Text":"YST",
"EnumGMTShort.26.Text":"CXST",
"EnumGMTShort.27.Text":"AWST",
"EnumGMTShort.28.Text":"SST",
"EnumGMTShort.29.Text":"ACST",
"EnumGMTShort.30.Text":"AEST",
"EnumGMTShort.31.Text":"MST",
"EnumGMTShort.32.Text":"NFST",
"EnumGMTShort.33.Text":"AST",
"EnumGMTShort.34.Text":"NAST",
"EnumGMTShortDLS.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34",
"EnumGMTShortDLS.0.Text":"None",
"EnumGMTShortDLS.1.Text":"DDT",
"EnumGMTShortDLS.2.Text":"SDT",
"EnumGMTShortDLS.3.Text":"HADT",
"EnumGMTShortDLS.4.Text":"AKDT",
"EnumGMTShortDLS.5.Text":"PDT",
"EnumGMTShortDLS.6.Text":"MDT",
"EnumGMTShortDLS.7.Text":"CDT",
"EnumGMTShortDLS.8.Text":"EDT",
"EnumGMTShortDLS.9.Text":"VDT",
"EnumGMTShortDLS.10.Text":"ADT",
"EnumGMTShortDLS.11.Text":"NDT",
"EnumGMTShortDLS.12.Text":"ESADT",
"EnumGMTShortDLS.13.Text":"MADT",
"EnumGMTShortDLS.14.Text":"CVDT",
"EnumGMTShortDLS.15.Text":"WDT",
"EnumGMTShortDLS.16.Text":"CEDT",
"EnumGMTShortDLS.17.Text":"EEDT",
"EnumGMTShortDLS.18.Text":"MSD",
"EnumGMTShortDLS.19.Text":"CDT",
"EnumGMTShortDLS.20.Text":"KDT",
"EnumGMTShortDLS.21.Text":"IDT",
"EnumGMTShortDLS.22.Text":"IST",
"EnumGMTShortDLS.23.Text":"KDT",
"EnumGMTShortDLS.24.Text":"ADDT",
"EnumGMTShortDLS.25.Text":"YDT",
"EnumGMTShortDLS.26.Text":"CXDT",
"EnumGMTShortDLS.27.Text":"AWDT",
"EnumGMTShortDLS.28.Text":"sdt",
"EnumGMTShortDLS.29.Text":"ACDT",
"EnumGMTShortDLS.30.Text":"AEDT",
"EnumGMTShortDLS.31.Text":"MDT",
"EnumGMTShortDLS.32.Text":"NFDT",
"EnumGMTShortDLS.33.Text":"ADT",
"EnumGMTShortDLS.34.Text":"NADT",
"EnumGMTLong.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34",
"EnumGMTLong.0.Text":"No Time Zone",
"EnumGMTLong.1.Text":"International Date Line West",
"EnumGMTLong.2.Text":"Midway Island, Samoa",
"EnumGMTLong.3.Text":"Hawaiian-Aleutian Time",
"EnumGMTLong.4.Text":"Alaska Time",
"EnumGMTLong.5.Text":"Pacific Time",
"EnumGMTLong.6.Text":"Mountain Time",
"EnumGMTLong.7.Text":"Central Time",
"EnumGMTLong.8.Text":"Eastern Time",
"EnumGMTLong.9.Text":"Caracas",
"EnumGMTLong.10.Text":"Atlantic Time",
"EnumGMTLong.11.Text":"Newfoundland Time",
"EnumGMTLong.12.Text":"Brazil",
"EnumGMTLong.13.Text":"Mid-Atlantic Time",
"EnumGMTLong.14.Text":"Azores",
"EnumGMTLong.15.Text":"Western European Time",
"EnumGMTLong.16.Text":"Central European Time",
"EnumGMTLong.17.Text":"Eastern European Time",
"EnumGMTLong.18.Text":"Moscow Time",
"EnumGMTLong.19.Text":"Caucasus Time",
"EnumGMTLong.20.Text":"Kabul",
"EnumGMTLong.21.Text":"Islamabad",
"EnumGMTLong.22.Text":"Mumbai",
"EnumGMTLong.23.Text":"Kathmandu",
"EnumGMTLong.24.Text":"Astana, Dhaka",
"EnumGMTLong.25.Text":"Yangoon",
"EnumGMTLong.26.Text":"Christmas Island Time",
"EnumGMTLong.27.Text":"Australian Western Time",
"EnumGMTLong.28.Text":"Seoul",
"EnumGMTLong.29.Text":"Australian Central Time",
"EnumGMTLong.30.Text":"Australian Eastern Time",
"EnumGMTLong.31.Text":"Magadan",
"EnumGMTLong.32.Text":"Norfolk (Island) Time",
"EnumGMTLong.33.Text":"Auckland",
"EnumGMTLong.34.Text":"Nuku'alofa",
"EnumGMTLongDLS.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34",
"EnumGMTLongDLS.0.Text":"No Time Zone",
"EnumGMTLongDLS.1.Text":"GMT-12:00 dl",
"EnumGMTLongDLS.2.Text":"GMT-11:00 dl",
"EnumGMTLongDLS.3.Text":"Hawaiian-Aleutian Time",
"EnumGMTLongDLS.4.Text":"Alaska Time",
"EnumGMTLongDLS.5.Text":"Pacific Time",
"EnumGMTLongDLS.6.Text":"Mountain Time",
"EnumGMTLongDLS.7.Text":"Central Time",
"EnumGMTLongDLS.8.Text":"Eastern Time",
"EnumGMTLongDLS.9.Text":"GMT-04:30 dl",
"EnumGMTLongDLS.10.Text":"Atlantic Time",
"EnumGMTLongDLS.11.Text":"Newfoundland Time",
"EnumGMTLongDLS.12.Text":"GMT-03:00 dl",
"EnumGMTLongDLS.13.Text":"GMT-02:00 dl",
"EnumGMTLongDLS.14.Text":"GMT-01:00 dl",
"EnumGMTLongDLS.15.Text":"Western European Time",
"EnumGMTLongDLS.16.Text":"Central European Time",
"EnumGMTLongDLS.17.Text":"Eastern European Time",
"EnumGMTLongDLS.18.Text":"Moscor Time",
"EnumGMTLongDLS.19.Text":"GMT+04:00 dl",
"EnumGMTLongDLS.20.Text":"GMT+04:30 dl",
"EnumGMTLongDLS.21.Text":"GMT+05:00 dl",
"EnumGMTLongDLS.22.Text":"GMT+05:30 dl",
"EnumGMTLongDLS.23.Text":"GMT+05:45 dl",
"EnumGMTLongDLS.24.Text":"GMT+06:00 dl",
"EnumGMTLongDLS.25.Text":"GMT+06:30 dl",
"EnumGMTLongDLS.26.Text":"GMT+07:00 dl",
"EnumGMTLongDLS.27.Text":"Australian Western Time",
"EnumGMTLongDLS.28.Text":"GMT+09:00 dl",
"EnumGMTLongDLS.29.Text":"Australian Central Time",
"EnumGMTLongDLS.30.Text":"Australian Eastern Time",
"EnumGMTLongDLS.31.Text":"GMT+11:00 dl",
"EnumGMTLongDLS.32.Text":"GMT+11:30 dl",
"EnumGMTLongDLS.33.Text":"GMT+12:00 dl",
"EnumGMTLongDLS.34.Text":"GMT+13:00 dl",
"EnumGMT.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34",
"EnumGMT.0.Text":"No Timezone",
"EnumGMT.1.Text":"GMT-12:00",
"EnumGMT.2.Text":"GMT-11:00",
"EnumGMT.3.Text":"GMT-10:00",
"EnumGMT.4.Text":"GMT-09:00",
"EnumGMT.5.Text":"GMT-08:00",
"EnumGMT.6.Text":"GMT-07:00",
"EnumGMT.7.Text":"GMT-06:00",
"EnumGMT.8.Text":"GMT-05:00",
"EnumGMT.9.Text":"GMT-04:30",
"EnumGMT.10.Text":"GMT-04:00",
"EnumGMT.11.Text":"GMT-03:30",
"EnumGMT.12.Text":"GMT-03:00",
"EnumGMT.13.Text":"GMT-02:00",
"EnumGMT.14.Text":"GMT-01:00",
"EnumGMT.15.Text":"GMT",
"EnumGMT.16.Text":"GMT+01:00",
"EnumGMT.17.Text":"GMT+02:00",
"EnumGMT.18.Text":"GMT+03:00",
"EnumGMT.19.Text":"GMT+04:00",
"EnumGMT.20.Text":"GMT+04:30",
"EnumGMT.21.Text":"GMT+05:00",
"EnumGMT.22.Text":"GMT+05:30",
"EnumGMT.23.Text":"GMT+05:45",
"EnumGMT.24.Text":"GMT+06:00",
"EnumGMT.25.Text":"GMT+06:30",
"EnumGMT.26.Text":"GMT+07:00",
"EnumGMT.27.Text":"GMT+08:00",
"EnumGMT.28.Text":"GMT+09:00",
"EnumGMT.29.Text":"GMT+09:30",
"EnumGMT.30.Text":"GMT+10:00",
"EnumGMT.31.Text":"GMT+11:00",
"EnumGMT.32.Text":"GMT+11:30",
"EnumGMT.33.Text":"GMT+12:00",
"EnumGMT.34.Text":"GMT+13:00",
"EnumGMTOffset.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34",
"EnumGMTOffset.0.Text":"NULL",
"EnumGMTOffset.1.Text":"-720",
"EnumGMTOffset.2.Text":"-660",
"EnumGMTOffset.3.Text":"-600",
"EnumGMTOffset.4.Text":"-540",
"EnumGMTOffset.5.Text":"-480",
"EnumGMTOffset.6.Text":"-420",
"EnumGMTOffset.7.Text":"-360",
"EnumGMTOffset.8.Text":"-300",
"EnumGMTOffset.9.Text":"-270",
"EnumGMTOffset.10.Text":"-240",
"EnumGMTOffset.11.Text":"-210",
"EnumGMTOffset.12.Text":"-180",
"EnumGMTOffset.13.Text":"-120",
"EnumGMTOffset.14.Text":"-60",
"EnumGMTOffset.15.Text":"0",
"EnumGMTOffset.16.Text":"60",
"EnumGMTOffset.17.Text":"120",
"EnumGMTOffset.18.Text":"180",
"EnumGMTOffset.19.Text":"240",
"EnumGMTOffset.20.Text":"270",
"EnumGMTOffset.21.Text":"300",
"EnumGMTOffset.22.Text":"330",
"EnumGMTOffset.23.Text":"345",
"EnumGMTOffset.24.Text":"360",
"EnumGMTOffset.25.Text":"390",
"EnumGMTOffset.26.Text":"420",
"EnumGMTOffset.27.Text":"480",
"EnumGMTOffset.28.Text":"540",
"EnumGMTOffset.29.Text":"570",
"EnumGMTOffset.30.Text":"600",
"EnumGMTOffset.31.Text":"660",
"EnumGMTOffset.32.Text":"690",
"EnumGMTOffset.33.Text":"720",
"EnumGMTOffset.34.Text":"780",
"EnumGMTOffsetDLS.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34",
"EnumGMTOffsetDLS.0.Text":"NULL",
"EnumGMTOffsetDLS.1.Text":"-660",
"EnumGMTOffsetDLS.2.Text":"-600",
"EnumGMTOffsetDLS.3.Text":"-540",
"EnumGMTOffsetDLS.4.Text":"-480",
"EnumGMTOffsetDLS.5.Text":"-420",
"EnumGMTOffsetDLS.6.Text":"-360",
"EnumGMTOffsetDLS.7.Text":"-300",
"EnumGMTOffsetDLS.8.Text":"-240",
"EnumGMTOffsetDLS.9.Text":"-210",
"EnumGMTOffsetDLS.10.Text":"-180",
"EnumGMTOffsetDLS.11.Text":"-150",
"EnumGMTOffsetDLS.12.Text":"-120",
"EnumGMTOffsetDLS.13.Text":"-60",
"EnumGMTOffsetDLS.14.Text":"0",
"EnumGMTOffsetDLS.15.Text":"60",
"EnumGMTOffsetDLS.16.Text":"120",
"EnumGMTOffsetDLS.17.Text":"180",
"EnumGMTOffsetDLS.18.Text":"240",
"EnumGMTOffsetDLS.19.Text":"300",
"EnumGMTOffsetDLS.20.Text":"330",
"EnumGMTOffsetDLS.21.Text":"360",
"EnumGMTOffsetDLS.22.Text":"390",
"EnumGMTOffsetDLS.23.Text":"405",
"EnumGMTOffsetDLS.24.Text":"420",
"EnumGMTOffsetDLS.25.Text":"450",
"EnumGMTOffsetDLS.26.Text":"480",
"EnumGMTOffsetDLS.27.Text":"540",
"EnumGMTOffsetDLS.28.Text":"600",
"EnumGMTOffsetDLS.29.Text":"630",
"EnumGMTOffsetDLS.30.Text":"660",
"EnumGMTOffsetDLS.31.Text":"720",
"EnumGMTOffsetDLS.32.Text":"750",
"EnumGMTOffsetDLS.33.Text":"780",
"EnumGMTOffsetDLS.34.Text":"840",
"Second_Text.Text":"Second",
"Seconds_Text.Text":"Seconds",
"ExcludeOption0.Text":"Show Only",
"ExcludeOption1.Text":"Exclude",
"VendorID_0.Text":"ASHRAE",
"VendorID_1.Text":"NIST",
"VendorID_2.Text":"Trane",
"VendorID_3.Text":"McQuay",
"VendorID_4.Text":"PolarSoft",
"VendorID_5.Text":"JCI",
"VendorID_6.Text":"American Auto-Matrix",
"VendorID_7.Text":"Siemens",
"VendorID_8.Text":"Delta",
"VendorID_9.Text":"Siemens",
"VendorID_10.Text":"Tour Andover",
"VendorID_11.Text":"TAC",
"VendorID_12.Text":"Orion",
"VendorID_13.Text":"Teletrol",
"VendorID_14.Text":"Cimetrics",
"VendorID_15.Text":"Cornell",
"VendorID_16.Text":"UTC",
"VendorID_17.Text":"Honeywell",
"VendorID_18.Text":"Alerton/Honeywell",
"VendorID_19.Text":"TAC AB",
"VendorID_20.Text":"HP",
"VendorID_21.Text":"Dorsette's",
"VendorID_22.Text":"Cerberus AG",
"VendorID_23.Text":"York",
"VendorID_24.Text":"ALC",
"VendorID_25.Text":"CSI",
"VendorID_26.Text":"Phoenix",
"VendorID_27.Text":"Innovex",
"VendorID_28.Text":"KMC",
"VendorID_29.Text":"Xn Technologies",
"VendorID_30.Text":"Hyundai",
"VendorID_31.Text":"Tokimec",
"VendorID_32.Text":"Simplex",
"VendorID_33.Text":"North Building Tech.",
"VendorID_34.Text":"Notifier",
"VendorID_35.Text":"Reliable",
"VendorID_36.Text":"Tridium",
"VendorID_37.Text":"Sierra",
"VendorID_38.Text":"Silicon Energy",
"VendorID_39.Text":"Kieback Peter",
"VendorID_40.Text":"Anacon",
"VendorID_41.Text":"SCI",
"VendorID_42.Text":"Lithonia",
"VendorID_43.Text":"Micropower",
"VendorID_44.Text":"Matrix",
"VendorID_45.Text":"METALAIRE",
"VendorID_46.Text":"ESS",
"VendorID_47.Text":"Sphere",
"VendorID_48.Text":"Walker Technologies",
"VendorID_49.Text":"H I Solutions",
"VendorID_50.Text":"MBS",
"VendorID_51.Text":"Samson",
"VendorID_52.Text":"Badger Meter",
"VendorID_53.Text":"DAIKIN",
"VendorID_54.Text":"NARA",
"VendorID_55.Text":"Mammoth",
"VendorID_56.Text":"Liebert",
"VendorID_57.Text":"SEMCO",
"VendorID_58.Text":"Air Monitor",
"VendorID_59.Text":"TRIATEK",
"VendorID_60.Text":"NexLight",
"VendorID_61.Text":"Multistack",
"VendorID_62.Text":"TSI",
"VendorID_63.Text":"Weather-Rite",
"VendorID_64.Text":"Dunham-Bush",
"VendorID_65.Text":"Reliance Electric",
"VendorID_66.Text":"LCS Inc.",
"VendorID_67.Text":"Regulator Australia",
"VendorID_68.Text":"Touch-Plate",
"VendorID_69.Text":"Amann",
"VendorID_70.Text":"RLE",
"VendorID_71.Text":"Cardkey",
"VendorID_72.Text":"SECOM",
"VendorID_73.Text":"ABB Gebäudetechnik",
"VendorID_74.Text":"KNX",
"VendorID_75.Text":"IEIEJ",
"VendorID_76.Text":"Nohmi Bosai",
"VendorID_77.Text":"Carel",
"VendorID_78.Text":"AirSense",
"VendorID_79.Text":"Hochiki",
"VendorID_80.Text":"Fr Sauter",
"VendorID_81.Text":"Matsushita Electric",
"VendorID_82.Text":"Mitsubishi Electric",
"VendorID_83.Text":"Mitsubishi Heavy Ind.",
"VendorID_84.Text":"ITT Bell & Gossett",
"VendorID_85.Text":"Yamatake",
"VendorID_86.Text":"Watt Stopper",
"VendorID_87.Text":"Aichi Tokei Denki",
"VendorID_88.Text":"Activation Tech",
"VendorID_89.Text":"Saia-Burgess",
"VendorID_90.Text":"Hitachi",
"VendorID_91.Text":"Novar",
"VendorID_92.Text":"Mitsubishi Lighting",
"VendorID_93.Text":"Argus",
"VendorID_94.Text":"Kyuki",
"VendorID_95.Text":"Richards-Zeta",
"VendorID_96.Text":"Scientech",
"VendorID_97.Text":"VCI",
"VendorID_98.Text":"Toshiba",
"VendorID_99.Text":"Mitsubishi Air Conditioning Refrigeration",
"VendorID_100.Text":"Custom Mechanical",
"VendorID_101.Text":"ClimateMaster",
"VendorID_102.Text":"ICP Panel-Tec",
"VendorID_103.Text":"D-Tek",
"VendorID_104.Text":"NEC Engineering",
"VendorID_105.Text":"PRIVA BV",
"VendorID_106.Text":"Meidensha",
"VendorID_107.Text":"JCI Systems Integration",
"VendorID_108.Text":"Freedom",
"VendorID_109.Text":"Neuberger",
"VendorID_110.Text":"Sitronix",
"VendorID_111.Text":"Leviton",
"VendorID_112.Text":"Fujitsu",
"VendorID_113.Text":"Emerson",
"VendorID_114.Text":"S. A. Armstrong",
"VendorID_115.Text":"Visonet",
"VendorID_116.Text":"M&M Systems",
"VendorID_117.Text":"Custom Software",
"VendorID_118.Text":"Nittan",
"VendorID_119.Text":"Elutions",
"VendorID_120.Text":"Pacom",
"VendorID_121.Text":"Unico",
"VendorID_122.Text":"Ebtron",
"VendorID_123.Text":"Scada Engine",
"VendorID_124.Text":"AC Technology",
"VendorID_125.Text":"Eagle",
"VendorID_126.Text":"Data Aire",
"VendorID_127.Text":"ABB, Inc.",
"VendorID_128.Text":"Transbit",
"VendorID_129.Text":"Toshiba Carrier",
"VendorID_130.Text":"Shenzhen Junzhi",
"VendorID_131.Text":"Tokai",
"VendorID_132.Text":"Blue Ridge",
"VendorID_133.Text":"Veris",
"VendorID_134.Text":"Centaurus",
"VendorID_135.Text":"Sand Network",
"VendorID_136.Text":"Regulvar",
"VendorID_137.Text":"Fastek",
"VendorID_138.Text":"PowerCold",
"VendorID_139.Text":"I Controls",
"VendorID_140.Text":"Viconics",
"VendorID_141.Text":"Yaskawa",
"VendorID_142.Text":"DEOS",
"VendorID_143.Text":"Digitale",
"VendorID_144.Text":"Fujitsu General",
"VendorID_145.Text":"Project Engineering",
"VendorID_146.Text":"Sanyo",
"VendorID_147.Text":"Integrated Info Sys",
"VendorID_148.Text":"Temco",
"VendorID_149.Text":"Airtek",
"VendorID_150.Text":"Advantech",
"VendorID_151.Text":"Titan",
"VendorID_152.Text":"Regel",
"VendorID_153.Text":"National Environmental",
"VendorID_154.Text":"Unitec",
"VendorID_155.Text":"Kanden Engineering",
"VendorID_156.Text":"Messner Gebäudetechnik",
"VendorID_157.Text":"Integrated.CH",
"VendorID_158.Text":"EH Price",
"VendorID_159.Text":"SE-Electronic",
"VendorID_160.Text":"Rockwell Automation",
"VendorID_161.Text":"Enflex Corp.",
"VendorID_162.Text":"ASI Controls",
"VendorID_163.Text":"SysMik Dresden",
"VendorID_164.Text":"HSC Regelungstechnik",
"VendorID_165.Text":"Smart Temp Australia",
"VendorID_166.Text":"Cooper Controls",
"VendorID_167.Text":"Duksan Mecasys",
"VendorID_168.Text":"Fuji IT",
"VendorID_169.Text":"Vacon Plc",
"VendorID_170.Text":"Leader Controls",
"VendorID_171.Text":"Cylon Controls",
"VendorID_172.Text":"Compas",
"VendorID_173.Text":"Mitsubishi Electric Building",
"VendorID_174.Text":"Building Control Integrators",
"VendorID_175.Text":"ITG Worldwide",
"VendorID_176.Text":"Lutron Electronics",
"VendorID_177.Text":"Cooper-Atkins",
"VendorID_178.Text":"LOYTEC Electronics",
"VendorID_179.Text":"ProLon",
"VendorID_180.Text":"Mega Controls",
"VendorID_181.Text":"Micro Control",
"VendorID_182.Text":"Kiyon",
"VendorID_183.Text":"Dust Networks",
"VendorID_184.Text":"Advanced Building Automation",
"VendorID_185.Text":"Hermos AG",
"VendorID_186.Text":"CEZIM",
"VendorID_187.Text":"Softing",
"VendorID_188.Text":"Lynxspring",
"VendorID_189.Text":"Schneider Toshiba",
"VendorID_190.Text":"Danfoss Drives",
"VendorID_191.Text":"Eaton",
"VendorID_192.Text":"Matyca",
"VendorID_193.Text":"Botech",
"VendorID_194.Text":"Noveo",
"VendorID_195.Text":"AMEV",
"VendorID_196.Text":"Yokogawa Electric",
"VendorID_197.Text":"GFR",
"VendorID_198.Text":"Exact Logic",
"VendorID_199.Text":"Mass Electronics Innotech Australia",
"VendorID_200.Text":"Kandenko",
"VendorID_201.Text":"DTF",
"VendorID_202.Text":"Klimasoft",
"VendorID_203.Text":"Toshiba Schneider Inverter",
"VendorID_204.Text":"Control Applications",
"VendorID_205.Text":"KDT Systems",
"VendorID_206.Text":"Onicon",
"VendorID_207.Text":"Automation Displays",
"VendorID_208.Text":"Control Solutions",
"VendorID_209.Text":"Remsdaq",
"VendorID_210.Text":"NTT Facilities",
"VendorID_211.Text":"VIPA GmbH",
"VendorID_212.Text":"TSC21 Association Japan",
"VendorID_213.Text":"BBP Energie",
"VendorID_214.Text":"HRW",
"VendorID_215.Text":"Lighting Control & Design",
"VendorID_216.Text":"Mercy Electronic and Electrical",
"VendorID_217.Text":"Samsung SDS",
"VendorID_218.Text":"Impact Facility Solutions",
"VendorID_219.Text":"Aircuity",
"VendorID_220.Text":"Control Techniques",
"VendorID_221.Text":"OpenGeneral",
"VendorID_222.Text":"WAGO Kontakttechnik",
"VendorID_223.Text":"Cerus Industrial",
"VendorID_224.Text":"Chloride Power Protection",
"VendorID_225.Text":"Computrols",
"VendorID_226.Text":"Phoenix Contact",
"VendorID_227.Text":"Grundfos Management",
"VendorID_228.Text":"Ridder Drive Systems",
"VendorID_229.Text":"Soft Device",
"VendorID_230.Text":"Integrated Control Technology",
"VendorID_231.Text":"AIRxpert",
"VendorID_232.Text":"Microtrol",
"VendorID_233.Text":"Red Lion",
"VendorID_234.Text":"Digital Electronics Corporation",
"VendorID_235.Text":"Ennovatis",
"VendorID_236.Text":"Serotonin",
"VendorID_237.Text":"LS Industrial Systems",
"VendorID_238.Text":"Square D",
"VendorID_239.Text":"S Squared",
"VendorID_240.Text":"Aricent",
"VendorID_241.Text":"EtherMetrics",
"VendorID_242.Text":"Industrial Control Communications",
"VendorID_243.Text":"Paragon Controls",
"VendorID_244.Text":"A. O. Smith",
"VendorID_245.Text":"Contemporary Control Systems",
"VendorID_246.Text":"Intesis Software",
"VendorID_247.Text":"Ingenieurgesellschaft N. Hartleb",
"VendorID_248.Text":"Heat-Timer",
"VendorID_249.Text":"Ingrasys Technology",
"VendorID_250.Text":"Costerm",
"VendorID_251.Text":"WILO SE",
"VendorID_252.Text":"Embedia Technologies",
"VendorID_253.Text":"Technilog",
"VendorID_254.Text":"HR Controls",
"VendorID_255.Text":"Lennox International",
"VendorID_256.Text":"RK-Tec Rauchklappen-Steuerungssysteme",
"VendorID_257.Text":"Thermomax",
"VendorID_258.Text":"ELCON Electronic",
"VendorID_259.Text":"Larmia Control",
"VendorID_260.Text":"BACnet Stack SourceForge",
"VendorID_261.Text":"G4S Security Services",
"VendorID_262.Text":"Sitek",
"VendorID_263.Text":"Cristal",
"VendorID_264.Text":"Regin",
"VendorID_265.Text":"Dimension Software",
"VendorID_266.Text":"SynapSense",
"VendorID_267.Text":"Beijing Nantree",
"VendorID_268.Text":"Camus Hydronics",
"VendorID_269.Text":"Kawasaki Heavy Industries",
"VendorID_270.Text":"Critical Environment",
"VendorID_271.Text":"ILSHIN IBS",
"VendorID_272.Text":"ELESTA Energy Control",
"VendorID_273.Text":"KROPMAN",
"VendorID_274.Text":"Baldor Electric Company",
"VendorID_275.Text":"INGA",
"VendorID_276.Text":"GE Consumer & Industrial",
"VendorID_277.Text":"Functional Devices",
"VendorID_278.Text":"ESAC",
"VendorID_279.Text":"M-System",
"VendorID_280.Text":"Yokota",
"VendorID_281.Text":"Hitranse Technology",
"VendorID_282.Text":"Federspiel",
"VendorID_283.Text":"Kele",
"VendorID_284.Text":"Opera Electronics",
"VendorID_285.Text":"Gentec",
"VendorID_286.Text":"Embedded Science Labs",
"VendorID_287.Text":"Parker Hannifin",
"VendorID_288.Text":"MaCaPS",
"VendorID_289.Text":"Link4",
"VendorID_290.Text":"Romutec S R",
"VendorID_291.Text":"Pribusin",
"VendorID_292.Text":"Advantage Controls",
"VendorID_293.Text":"Critical Room Control",
"VendorID_294.Text":"LEGRAND",
"VendorID_295.Text":"Tongdy",
"VendorID_296.Text":"ISSARO",
"VendorID_297.Text":"Pro-Dev",
"VendorID_298.Text":"DRI-STEEM",
"VendorID_299.Text":"Creative Electronic GmbH",
"VendorID_300.Text":"Swegon AB",
"VendorID_301.Text":"Jan Brachacek",
"VendorID_302.Text":"Hitachi Appliances",
"VendorID_303.Text":"Real Time",
"VendorID_304.Text":"ITEC Hankyu-Hanshin",
"VendorID_305.Text":"Cyrus E&M Engineering",
"VendorID_306.Text":"Racine Federated",
"VendorID_307.Text":"Verari",
"VendorID_308.Text":"Elesta",
"VendorID_309.Text":"Securiton",
"VendorID_310.Text":"Oslsoft",
"VendorID_311.Text":"Hanazeder Electronic",
"VendorID_312.Text":"Honeywell Security Deutschland Novar",
"VendorID_313.Text":"Siemens Energy & Automation",
"VendorID_314.Text":"ETM Professional",
"VendorID_315.Text":"Meitav-tec",
"VendorID_316.Text":"Janitza Electronics",
"VendorID_317.Text":"MKS Nordhausen",
"VendorID_318.Text":"De Gier Drive Systems",
"VendorID_319.Text":"Cypress Envirosystems",
"VendorID_320.Text":"SMARTron",
"VendorID_321.Text":"Verari",
"VendorID_322.Text":"K-W Electronic Service",
"VendorID_323.Text":"ALFA-SMART",
"VendorID_324.Text":"Telkonet",
"VendorID_325.Text":"Securiton",
"VendorID_326.Text":"Cemtrex",
"VendorID_327.Text":"Performance Technologies",
"VendorID_328.Text":"Xtralis Aust",
"VendorID_329.Text":"TROX",
"VendorID_330.Text":"Beijing Hysine Technology",
"VendorID_331.Text":"RCK",
"VendorID_332.Text":"ACELIA",
"VendorID_333.Text":"Novar/Honeywell",
"VendorID_334.Text":"The S4 Group",
"VendorID_335.Text":"Schneider Electric",
"VendorID_336.Text":"LHA Systems",
"VendorID_337.Text":"GHM engineering",
"VendorID_338.Text":"Cllimalux S.A.",
"VendorID_339.Text":"VAISALA",
"VendorID_340.Text":"COMPLEX Beijing",
"VendorID_341.Text":"SCADAmetrics",
"VendorID_342.Text":"POWERPEG NSI",
"VendorID_343.Text":"BACnet Interoperability Testing",
"VendorID_344.Text":"Teco a.s.",
"VendorID_345.Text":"Plexus Technology",
"VendorID_346.Text":"Energy Focus",
"VendorID_347.Text":"Powersmiths International",
"VendorID_348.Text":"Nichibei",
"VendorID_349.Text":"HKC Technology",
"VendorID_350.Text":"Ovation Networks",
"VendorID_351.Text":"Setra",
"VendorID_352.Text":"AVG",
"VendorID_353.Text":"ZXC",
"VendorID_354.Text":"Byte Sphere",
"VendorID_355.Text":"Generiton",
"VendorID_356.Text":"Holter Regelarmaturen",
"VendorID_357.Text":"Bedford Instruments",
"VendorID_358.Text":"Standair",
"VendorID_359.Text":"WEG Automation",
"VendorID_360.Text":"Prolon",
"VendorID_361.Text":"Inneasoft",
"VendorID_362.Text":"ConneXSoft",
"VendorID_363.Text":"CEAG Notlichtsysteme",
"VendorID_364.Text":"Distech Controls",
"VendorID_365.Text":"Industrial Technology Research Institute",
"VendorID_366.Text":"ICONICS",
"VendorID_367.Text":"IQ Controls",
"VendorID_368.Text":"OJ Electronics",
"VendorID_369.Text":"Rolbit Ltd.",
"VendorID_370.Text":"Synapsys Solutions",
"VendorID_371.Text":"ACME Engineering",
"VendorID_372.Text":"Zener Electric",
"VendorID_373.Text":"Selectronix",
"VendorID_374.Text":"Gorbet & Banerjee",
"VendorID_375.Text":"IME",
"VendorID_376.Text":"Stephen H. Dawson",
"VendorID_377.Text":"Accutrol",
"VendorID_378.Text":"Schneider Elektronik",
"VendorID_379.Text":"Alpha-Inno Tec",
"VendorID_380.Text":"ADMMicro",
"VendorID_381.Text":"Greystone Energy",
"VendorID_382.Text":"CAP",
"VendorID_383.Text":"KeRo",
"VendorID_384.Text":"Domat",
"VendorID_385.Text":"Efektronics",
"VendorID_386.Text":"Hekatron Vertriebs",
"VendorID_387.Text":"Securiton",
"VendorID_388.Text":"Carlo Gavazzi",
"VendorID_389.Text":"Chipkin",
"VendorID_390.Text":"Savant Systems",
"VendorID_391.Text":"Simmtronic Lighting",
"VendorID_392.Text":"Abelko Innovation",
"VendorID_393.Text":"Seresco Technologies",
"VendorID_394.Text":"IT Watchdogs",
"VendorID_395.Text":"Automation Assist Japan",
"VendorID_396.Text":"Thermokon Sensortechnik",
"VendorID_397.Text":"EGauge Systems",
"VendorID_398.Text":"Quantum Automation ASIA",
"VendorID_399.Text":"Logistics Systems & Software",
"VendorID_400.Text":"Logistics Systems & Software",
"VendorID_401.Text":"Logistics Systems & Software",
"VendorID_402.Text":"Delta Controls Integration",
"VendorID_403.Text":"Focus Media",
"VendorID_404.Text":"LUMEnergi",
"VendorID_Unknown.Text":"Unknown",
"CountryName.AF.Text":"Afghanistan",
"CountryName.AL.Text":"Albania",
"CountryName.DZ.Text":"Algeria",
"CountryName.AS.Text":"American Samoa",
"CountryName.AD.Text":"Andorra",
"CountryName.AO.Text":"Angola",
"CountryName.AI.Text":"Anguilla",
"CountryName.AQ.Text":"Antarctica",
"CountryName.AG.Text":"Antigua and Barbuda",
"CountryName.AR.Text":"Argentina",
"CountryName.AM.Text":"Armenia",
"CountryName.AW.Text":"Aruba",
"CountryName.AU.Text":"Australia",
"CountryName.AT.Text":"Austria",
"CountryName.AZ.Text":"Azerbaijan",
"CountryName.BS.Text":"Bahamas",
"CountryName.BH.Text":"Bahrain",
"CountryName.BD.Text":"Bangladesh",
"CountryName.BB.Text":"Barbados",
"CountryName.BY.Text":"Belarus",
"CountryName.BE.Text":"Belgium",
"CountryName.BZ.Text":"Belize",
"CountryName.BJ.Text":"Benin",
"CountryName.BM.Text":"Bermuda",
"CountryName.BT.Text":"Bhutan",
"CountryName.BO.Text":"Bolivia",
"CountryName.BA.Text":"Bosnia and Herzegovina",
"CountryName.BW.Text":"Botswana",
"CountryName.BV.Text":"Bouvet Island",
"CountryName.BR.Text":"Brazil",
"CountryName.IO.Text":"British Indian Ocean Territory",
"CountryName.VG.Text":"British Virgin Islands",
"CountryName.BN.Text":"Brunei",
"CountryName.BG.Text":"Bulgaria",
"CountryName.BF.Text":"Burkina Faso",
"CountryName.MM.Text":"Burma",
"CountryName.BI.Text":"Burundi",
"CountryName.KH.Text":"Cambodia",
"CountryName.CM.Text":"Cameroon",
"CountryName.CA.Text":"Canada",
"CountryName.CV.Text":"Cape Verde",
"CountryName.KY.Text":"Cayman Islands",
"CountryName.CF.Text":"Central African Republic",
"CountryName.TD.Text":"Chad",
"CountryName.CL.Text":"Chile",
"CountryName.CN.Text":"China",
"CountryName.CX.Text":"Christmas Island",
"CountryName.CC.Text":"Cocos (Keeling) Islands",
"CountryName.CO.Text":"Colombia",
"CountryName.KM.Text":"Comoros",
"CountryName.CG.Text":"Congo, Democratic Republic of the",
"CountryName.CD.Text":"Congo, Republic of the",
"CountryName.CK.Text":"Cook Islands",
"CountryName.CR.Text":"Costa Rica",
"CountryName.CI.Text":"Cote d'Ivoire",
"CountryName.HR.Text":"Croatia",
"CountryName.CU.Text":"Cuba",
"CountryName.CY.Text":"Cyprus",
"CountryName.CZ.Text":"Czech Republic",
"CountryName.DK.Text":"Denmark",
"CountryName.DJ.Text":"Djibouti",
"CountryName.DM.Text":"Dominica",
"CountryName.DO.Text":"Dominican Republic",
"CountryName.EC.Text":"Ecuador",
"CountryName.EG.Text":"Egypt",
"CountryName.SV.Text":"El Salvador",
"CountryName.GQ.Text":"Equatorial Guinea",
"CountryName.ER.Text":"Eritrea",
"CountryName.EE.Text":"Estonia",
"CountryName.ET.Text":"Ethiopia",
"CountryName.FK.Text":"Falkland Islands (Islas Malvinas)",
"CountryName.FO.Text":"Faroe Islands",
"CountryName.FJ.Text":"Fiji",
"CountryName.FI.Text":"Finland",
"CountryName.FR.Text":"France",
"CountryName.GF.Text":"French Guiana",
"CountryName.PF.Text":"French Polynesia",
"CountryName.TF.Text":"French Southern and Antarctic Lands",
"CountryName.GA.Text":"Gabon",
"CountryName.GM.Text":"Gambia",
"CountryName.GE.Text":"Georgia",
"CountryName.DE.Text":"Germany",
"CountryName.GH.Text":"Ghana",
"CountryName.GI.Text":"Gibraltar",
"CountryName.GR.Text":"Greece",
"CountryName.GL.Text":"Greenland",
"CountryName.GD.Text":"Grenada",
"CountryName.GP.Text":"Guadeloupe",
"CountryName.GU.Text":"Guam",
"CountryName.GT.Text":"Guatemala",
"CountryName.GG.Text":"Guernsey",
"CountryName.GN.Text":"Guinea",
"CountryName.GW.Text":"Guinea-Bissau",
"CountryName.GY.Text":"Guyana",
"CountryName.HT.Text":"Haiti",
"CountryName.HM.Text":"Heard Island and McDonald Islands",
"CountryName.VA.Text":"Vatican City (Holy See)",
"CountryName.HN.Text":"Honduras",
"CountryName.HK.Text":"Hong Kong",
"CountryName.HU.Text":"Hungary",
"CountryName.IS.Text":"Iceland",
"CountryName.IN.Text":"India",
"CountryName.ID.Text":"Indonesia",
"CountryName.IR.Text":"Iran",
"CountryName.IQ.Text":"Iraq",
"CountryName.IE.Text":"Ireland",
"CountryName.IM.Text":"Isle of Man",
"CountryName.IL.Text":"Israel",
"CountryName.IT.Text":"Italy",
"CountryName.JM.Text":"Jamaica",
"CountryName.JP.Text":"Japan",
"CountryName.JE.Text":"Jersey",
"CountryName.JO.Text":"Jordan",
"CountryName.KZ.Text":"Kazakhstan",
"CountryName.KE.Text":"Kenya",
"CountryName.KI.Text":"Kiribati",
"CountryName.KP.Text":"North Korea",
"CountryName.KR.Text":"South Korea",
"CountryName.KW.Text":"Kuwait",
"CountryName.KG.Text":"Kyrgyzstan",
"CountryName.LA.Text":"Laos",
"CountryName.LV.Text":"Latvia",
"CountryName.LB.Text":"Lebanon",
"CountryName.LS.Text":"Lesotho",
"CountryName.LR.Text":"Liberia",
"CountryName.LY.Text":"Libya",
"CountryName.LI.Text":"Liechtenstein",
"CountryName.LT.Text":"Lithuania",
"CountryName.LU.Text":"Luxembourg",
"CountryName.MO.Text":"Macau",
"CountryName.MK.Text":"Macedonia",
"CountryName.MG.Text":"Madagascar",
"CountryName.MW.Text":"Malawi",
"CountryName.MY.Text":"Malaysia",
"CountryName.MV.Text":"Maldives",
"CountryName.ML.Text":"Mali",
"CountryName.MT.Text":"Malta",
"CountryName.MH.Text":"Marshall Islands",
"CountryName.MQ.Text":"Martinique",
"CountryName.MR.Text":"Mauritania",
"CountryName.MU.Text":"Mauritius",
"CountryName.YT.Text":"Mayotte",
"CountryName.MX.Text":"Mexico",
"CountryName.FM.Text":"Micronesia, Federated States of",
"CountryName.MD.Text":"Moldova",
"CountryName.MC.Text":"Monaco",
"CountryName.MN.Text":"Mongolia",
"CountryName.MS.Text":"Montserrat",
"CountryName.MA.Text":"Morocco",
"CountryName.MZ.Text":"Mozambique",
"CountryName.NA.Text":"Namibia",
"CountryName.NR.Text":"Nauru",
"CountryName.NP.Text":"Nepal",
"CountryName.NL.Text":"Netherlands",
"CountryName.AN.Text":"Netherlands Antilles",
"CountryName.NC.Text":"New Caledonia",
"CountryName.NZ.Text":"New Zealand",
"CountryName.NI.Text":"Nicaragua",
"CountryName.NE.Text":"Niger",
"CountryName.NG.Text":"Nigeria",
"CountryName.NU.Text":"Niue",
"CountryName.NF.Text":"Norfolk Island",
"CountryName.MP.Text":"Northern Mariana Islands",
"CountryName.NO.Text":"Norway",
"CountryName.OM.Text":"Oman",
"CountryName.PK.Text":"Pakistan",
"CountryName.PW.Text":"Palau",
"CountryName.PA.Text":"Panama",
"CountryName.PG.Text":"Papua New Guinea",
"CountryName.PY.Text":"Paraguay",
"CountryName.PE.Text":"Peru",
"CountryName.PH.Text":"Philippines",
"CountryName.PN.Text":"Pitcairn Islands",
"CountryName.PL.Text":"Poland",
"CountryName.PT.Text":"Portugal",
"CountryName.PR.Text":"Puerto Rico",
"CountryName.QA.Text":"Qatar",
"CountryName.RE.Text":"Reunion",
"CountryName.RO.Text":"Romania",
"CountryName.RU.Text":"Russia",
"CountryName.RW.Text":"Rwanda",
"CountryName.SH.Text":"Saint Helena",
"CountryName.KN.Text":"Saint Kitts and Nevis",
"CountryName.LC.Text":"Saint Lucia",
"CountryName.PM.Text":"Saint Pierre and Miquelon",
"CountryName.VC.Text":"Saint Vincent and the Grenadines",
"CountryName.WS.Text":"Samoa",
"CountryName.SM.Text":"San Marino",
"CountryName.ST.Text":"Sao Tome and Principe",
"CountryName.SA.Text":"Saudi Arabia",
"CountryName.SN.Text":"Senegal",
"CountryName.RS.Text":"Serbia and Montenegro",
"CountryName.SC.Text":"Seychelles",
"CountryName.SL.Text":"Sierra Leone",
"CountryName.SG.Text":"Singapore",
"CountryName.SK.Text":"Slovakia",
"CountryName.SI.Text":"Slovenia",
"CountryName.SB.Text":"Solomon Islands",
"CountryName.SO.Text":"Somalia",
"CountryName.ZA.Text":"South Africa",
"CountryName.GS.Text":"South Georgia and the South Sandwich Islands",
"CountryName.ES.Text":"Spain",
"CountryName.LK.Text":"Sri Lanka",
"CountryName.SD.Text":"Sudan",
"CountryName.SR.Text":"Suriname",
"CountryName.SJ.Text":"Svalbard",
"CountryName.SZ.Text":"Swaziland",
"CountryName.SE.Text":"Sweden",
"CountryName.CH.Text":"Switzerland",
"CountryName.SY.Text":"Syria",
"CountryName.TW.Text":"Taiwan",
"CountryName.TJ.Text":"Tajikistan",
"CountryName.TZ.Text":"Tanzania",
"CountryName.TH.Text":"Thailand",
"CountryName.TL.Text":"Timor-Leste",
"CountryName.TG.Text":"Togo",
"CountryName.TK.Text":"Tokelau",
"CountryName.TO.Text":"Tonga",
"CountryName.TT.Text":"Trinidad and Tobago",
"CountryName.TN.Text":"Tunisia",
"CountryName.TR.Text":"Turkey",
"CountryName.TM.Text":"Turkmenistan",
"CountryName.TC.Text":"Turks and Caicos Islands",
"CountryName.TV.Text":"Tuvalu",
"CountryName.UG.Text":"Uganda",
"CountryName.UA.Text":"Ukraine",
"CountryName.AE.Text":"United Arab Emirates",
"CountryName.GB.Text":"United Kingdom",
"CountryName.US.Text":"United States",
"CountryName.UY.Text":"Uruguay",
"CountryName.UZ.Text":"Uzbekistan",
"CountryName.VU.Text":"Vanuatu",
"CountryName.VE.Text":"Venezuela",
"CountryName.VN.Text":"Vietnam",
"CountryName.VI.Text":"Virgin Islands",
"CountryName.WF.Text":"Wallis and Futuna",
"CountryName.EH.Text":"Western Sahara",
"CountryName.YE.Text":"Yemen",
"CountryName.ZM.Text":"Zambia",
"CountryName.ZW.Text":"Zimbabwe",
"OK.Text":"Ok",
"AutoLogOffExtend.Text":"Extend Session",
"AutoLogOffLogout.Text":"Logout",
"StateName.1.Text":"Alaska (AK)",
"StateName.2.Text":"Alabama (AL)",
"StateName.3.Text":"Arizona (AZ)",
"StateName.4.Text":"Arkansas (AR)",
"StateName.5.Text":"California (CA)",
"StateName.6.Text":"Colorado (CO)",
"StateName.7.Text":"Connecticut (CT)",
"StateName.8.Text":"Delaware (DE)",
"StateName.9.Text":"Florida (FL)",
"StateName.10.Text":"Georgia (GA)",
"StateName.11.Text":"Hawaii (HI)",
"StateName.12.Text":"Idaho (ID)",
"StateName.13.Text":"Illinois (IL)",
"StateName.14.Text":"Indiana (IN)",
"StateName.15.Text":"Iowa (IA)",
"StateName.16.Text":"Kansas (KS)",
"StateName.17.Text":"Kentucky (KY)",
"StateName.18.Text":"Louisiana (LA)",
"StateName.19.Text":"Maine (ME)",
"StateName.20.Text":"Maryland (MD)",
"StateName.21.Text":"Massachusetts (MA)",
"StateName.22.Text":"Michigan (MI)",
"StateName.23.Text":"Minnesota (MN)",
"StateName.24.Text":"Mississippi (MS)",
"StateName.25.Text":"Missouri (MO)",
"StateName.26.Text":"Montana (MT)",
"StateName.27.Text":"Nebraska (NE)",
"StateName.28.Text":"Nevada (NV)",
"StateName.29.Text":"New Hampshire (NH)",
"StateName.30.Text":"New Jersey (NJ)",
"StateName.31.Text":"New Mexico (NM)",
"StateName.32.Text":"New York (NY)",
"StateName.33.Text":"North Carolina (NC)",
"StateName.34.Text":"North Dakota (ND)",
"StateName.35.Text":"Ohio (OH)",
"StateName.36.Text":"Oklahoma (OK)",
"StateName.37.Text":"Oregon (OR)",
"StateName.38.Text":"Pennsylvania (PA)",
"StateName.39.Text":"Rhode Island (RI)",
"StateName.40.Text":"South Carolina (SC)",
"StateName.41.Text":"South Dakota (SD)",
"StateName.42.Text":"Tennessee (TN)",
"StateName.43.Text":"Texas (TX)",
"StateName.44.Text":"Utah (UT)",
"StateName.45.Text":"Vermont (VT)",
"StateName.46.Text":"Virginia (VA)",
"StateName.47.Text":"Washington (WA)",
"StateName.48.Text":"West Virginia (WV)",
"StateName.49.Text":"Wisconsin (WI)",
"StateName.50.Text":"Wyoming (WY)",
"StateName.51.Text":"Alberta",
"StateName.52.Text":"British Columbia",
"StateName.53.Text":"Manitoba",
"StateName.54.Text":"New Brunswick",
"StateName.55.Text":"Newfoundland and Labrador",
"StateName.56.Text":"Nova Scotia",
"StateName.57.Text":"Ontario",
"StateName.58.Text":"Prince Edward Island",
"StateName.59.Text":"Quebec",
"StateName.60.Text":"Saskatchewan",
"StateName.61.Text":"Northwest Territories",
"StateName.62.Text":"Nunavut",
"StateName.63.Text":"Yukon",
"StateName.64.Text":"District of Columbia (DC)",
"RunReports.Heading.Text":"Run Report",
"RunReports.UA.Text":"Select the report type and click Run Report to run the selected report for the selected buildings.",
"RunReports.ReportType.Text":"Report Type*",
"RunReports.ButtonCancel.Text":"Cancel",
"RunReports.ButtonReports.Text":"Run Reports",
"RunReports.ButtonRunReport.Text":"Run Report",
"EnumRunReports.TransactionType.Text":"21,44,83",
"EnumRunReports.TransactionType.21.Text":"All Points in Alarm",
"EnumRunReports.TransactionType.44.Text":"All Points in Override",
"EnumRunReports.TransactionType.83.Text":"Site Commissioning",
"EnumRunReports.BOWSTransactionType.Text":"95,96,97",
"EnumRunReports.BOWSTransactionType.95.Text":"Alarm Summary",
"EnumRunReports.BOWSTransactionType.96.Text":"Enrollment Summary",
"EnumRunReports.BOWSTransactionType.97.Text":"Event Summary",
"DeepLink.Heading.Text":"Direct Link to Panel",
"EnumWeekDays.Text":"0,1,2,3,4,5,6",
"EnumWeekDays.0.Text":"Sunday",
"EnumWeekDays.1.Text":"Monday",
"EnumWeekDays.2.Text":"Tuesday",
"EnumWeekDays.3.Text":"Wednesday",
"EnumWeekDays.4.Text":"Thursday",
"EnumWeekDays.5.Text":"Friday",
"EnumWeekDays.6.Text":"Saturday",
"EnumDayOfMonth.Text":"1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31",
"EnumDayOfMonth.1.Text":"1",
"EnumDayOfMonth.2.Text":"2",
"EnumDayOfMonth.3.Text":"3",
"EnumDayOfMonth.4.Text":"4",
"EnumDayOfMonth.5.Text":"5",
"EnumDayOfMonth.6.Text":"6",
"EnumDayOfMonth.7.Text":"7",
"EnumDayOfMonth.8.Text":"8",
"EnumDayOfMonth.9.Text":"9",
"EnumDayOfMonth.10.Text":"10",
"EnumDayOfMonth.11.Text":"11",
"EnumDayOfMonth.12.Text":"12",
"EnumDayOfMonth.13.Text":"13",
"EnumDayOfMonth.14.Text":"14",
"EnumDayOfMonth.15.Text":"15",
"EnumDayOfMonth.16.Text":"16",
"EnumDayOfMonth.17.Text":"17",
"EnumDayOfMonth.18.Text":"18",
"EnumDayOfMonth.19.Text":"19",
"EnumDayOfMonth.20.Text":"20",
"EnumDayOfMonth.21.Text":"21",
"EnumDayOfMonth.22.Text":"22",
"EnumDayOfMonth.23.Text":"23",
"EnumDayOfMonth.24.Text":"24",
"EnumDayOfMonth.25.Text":"25",
"EnumDayOfMonth.26.Text":"26",
"EnumDayOfMonth.27.Text":"27",
"EnumDayOfMonth.28.Text":"28",
"EnumDayOfMonth.29.Text":"29",
"EnumDayOfMonth.30.Text":"30",
"EnumDayOfMonth.31.Text":"31",
"EnumNumberOfWeek.Text":"1,2,3,4,5,6,7,8,9",
"EnumNumberOfWeek.1.Text":"First",
"EnumNumberOfWeek.2.Text":"Second",
"EnumNumberOfWeek.3.Text":"Third",
"EnumNumberOfWeek.4.Text":"Fourth",
"EnumNumberOfWeek.5.Text":"Fifth",
"EnumNumberOfWeek.6.Text":"Last",
"EnumNumberOfWeek.7.Text":"Second to Last",
"EnumNumberOfWeek.8.Text":"Third to Last",
"EnumNumberOfWeek.9.Text":"Fourth to Last",
"EnumRecurrenceWeekdays.Text":"1,2,3,4,5,6,7",
"EnumRecurrenceWeekdays.1.Text":"Monday",
"EnumRecurrenceWeekdays.2.Text":"Tuesday",
"EnumRecurrenceWeekdays.3.Text":"Wednesday",
"EnumRecurrenceWeekdays.4.Text":"Thursday",
"EnumRecurrenceWeekdays.5.Text":"Friday",
"EnumRecurrenceWeekdays.6.Text":"Saturday",
"EnumRecurrenceWeekdays.7.Text":"Sunday",
"EnumMonths.Text":"1,2,3,4,5,6,7,8,9,10,11,12",
"EnumMonths.1.Text":"January",
"EnumMonths.2.Text":"February",
"EnumMonths.3.Text":"March",
"EnumMonths.4.Text":"April",
"EnumMonths.5.Text":"May",
"EnumMonths.6.Text":"June",
"EnumMonths.7.Text":"July",
"EnumMonths.8.Text":"August",
"EnumMonths.9.Text":"September",
"EnumMonths.10.Text":"October",
"EnumMonths.11.Text":"November",
"EnumMonths.12.Text":"December",
"EnumWildCardMonths.Text":"13,14,255",
"EnumWildCardMonths.13.Text":"odd",
"EnumWildCardMonths.14.Text":"even",
"EnumWildCardMonths.255.Text":"every",
"EnumOddEvenMonths.Text":"255,13,14",
"EnumOddEvenMonths.255.Text":"every month on",
"EnumOddEvenMonths.13.Text":"every odd month on",
"EnumOddEvenMonths.14.Text":"every even month on",
"RecurrancePattern.rbtnSingleDay.Text":"Single Date",
"RecurrancePattern.rbtnDateRange.Text":"Date Range",
"RecurrancePattern.rbtnWeekly.Text":"Weekly",
"RecurrancePattern.rbtnMonthly.Text":"Monthly",
"RecurrancePattern.rbtnYearly.Text":"Yearly",
"RecurrancePattern.rbtnCalendar.Text":"Calendar",
"RecurrancePattern.lblDateRageUserAssist.Text":"Recur each day between",
"RecurrancePattern.lblWeeklyUserAssist.Text":"Recur every week on",
"RecurrancePattern.lblMonthlyUserAssist.Text":"Recur every month on",
"RecurrancePattern.lblMonthlyRecur.Text":"Recur",
"RecurrancePattern.rbtnDay.Text":"Day",
"RecurrancePattern.rbtnLastDayOfMonth.Text":"Last day of month",
"RecurrancePattern.rbtnThe.Text":"The",
"RecurrancePattern.lblYearlyUserAssist.Text":"Recur every year on",
"RecurrancePattern.rbtnOf.Text":"of",
"RecurrancePattern.lblCalendarName.Text":"Name",
"RecurrencePattern.lblStartDate.Text":"Start Date",
"RecurrencePattern.lblEndDate.Text":"End Date",
"RecurrencePattern.Monday.Text":"Monday",
"RecurrencePattern.Tuesday.Text":"Tuesday",
"RecurrencePattern.Wednesday.Text":"Wednesday",
"RecurrencePattern.Thursday.Text":"Thursday",
"RecurrencePattern.Friday.Text":"Friday",
"RecurrencePattern.Sunday.Text":"Sunday",
"RecurrencePattern.Saturday.Text":"Saturday",
"SetpointValue.Infinity.Text":"Infinity",
"EnumBuildingGroup.cboForColumn.Text":"0,1,BUILDING_GROUP",
"EnumBuildingGroup.cboForColumn.0.Text":"No Filter",
"EnumBuildingGroup.cboForColumn.1.Text":"Name",
"EnumBuildingGroup.cboForColumn.BUILDING_GROUP.Text":"Subgroup",
"BuildingGroup.Name.Text":"Name",
"BuildingGroup.Subgroup.Text":"Subgroup",
"SqlErrorcode.Text":"-2",
"SqlErrorcode.-2.Text":"The quantity of alarms you requested is too large.  Please filter for smaller amount",
"PointStatus.Subgroup.Text":"Subgroup",
"EnumPointStatus.cboForColumn.0.Text":"No Filters, view all",
"EnumPointStatus.cboForColumn.1.Text":"Point Name",
"EnumPointStatus.cboForColumn.BUILDING_GROUP.Text":"Subgroup",
"EnumPointStatus.cboForColumn.Text":"0,1,BUILDING_GROUP",
"GlobalChanges.PointName.Text":"Point Name",
"GlobalChanges.DeviceName.Text":"Device Name",
"GlobalChanges.DeviceID.Text":"Device ID",
"GlobalChanges.BuildingName.Text":"Building Name",
"GlobalChanges.PointType.Text":"Point Type",
"GlobalChanges.DataType.Text":"Data Type",
"EnumGlobalChanges.cboForColumn.0.Text":"No Filters, view all",
"EnumGlobalChanges.cboForColumn.1.Text":"Point Name",
"EnumGlobalChanges.cboForColumn.2.Text":"Device Name",
"EnumGlobalChanges.cboForColumn.3.Text":"Device ID",
"EnumGlobalChanges.cboForColumn.4.Text":"Building Name",
"EnumGlobalChanges.cboForColumn.5.Text":"Point Type",
"EnumGlobalChanges.cboForColumn.6.Text":"Data Type",
"EnumGlobalChanges.cboForColumn.Text":"0,1,2,3,4,5,6",
"ContextHeaderText.TracerInLogin.Text":"Tracer",
"ContextHeaderText.EnsembleInLogin.Text":"Ensemble™",
"ContextHeaderText.Tracer.Text":"Tracer® Ensemble™",
"ContextHeaderText.Reports.Text":"Reports",
"ContextHeaderText.ActionsAndSettings.Text":"Actions and Settings",
"Schedule.EventTypeNightEconomize.Text":"Night Economize Start",
"ManageStandardReport.FirstName.Text":"First Name",
"ManageStandardReport.LastName.Text":"Last Name",
"ManageStandardReport.EmailAddress.Text":"E-mail Address",
"EmailAddressError.Text":"Error: Recipient is not a known name or is not in the correct e-mail address format.",
"Master.Building.Text":"Building",
"Master.Tree.Text":"Tree",
"Master.Search.Text":"Search",
"Master.SearchAllBuildings.Text":"SearchAllBuildings",
"Master.AllBuilding.Text":"All Buildings",
"Layout.AllBuilding.Text":"Building List",
"DifferentUnitsError.Text":"Warning: The points selected have different units.",
"ViewDesktop.Text":"View Desktop Version",
"BuildingHealth.Notes.Text":"Notes",
"BuildingHealth.btnPost.Text":"Post Message",
"BuildingHealth.btnClose.Text":"Close Window",
"BuildingHealth.btnClearAllMessages.Text":"Clear All",
"BuildingHealth.Norecord.Text":"No notes exist for this building",
"DateFormat.dd/mm/yyyy.Text":"dd/mm/yyyy",
"DateFormat.mm/dd/yyyy.Text":"mm/dd/yyyy",
"DateFormat.yyyy/mm/dd.Text":"yyyy/mm/dd",
"TimeFormat.0.Text":"hh:mm tt",
"TimeFormat.1.Text":"HH:mm",
"virtualbuilding.Header.Text":"Create Virtual Buildings",
"virtualbuilding.EditHeader.Text":"Edit Virtual Buildings",
"virtualbuilding.Discovered.header.Text":"Discovered Building -",
"virtualbuilding.subHeader.Text":"Select items by clicking on them. Use Ctrl-click to select multiple items. Use Shift-click to select a range of consecutive items. The same item can be assigned to multiple virtual buildings.",
"ManageVirtualBuilding.Header.Text":"Discovered and Virtual Buildings",
"ManageVirtualBuilding.SubHeader.Text":"To create a virtual building, click on the discovered building which contains the desired equipment.",
"ManageVirtualBuilding.ColumnHeader1.Text":"Name",
"ManageVirtualBuilding.ColumnHeader2.Text":"Type",
"virtualbuilding.btncancel.Text":"Cancel",
"virtualbuilding.btnapply.Text":"Apply",
"virtualbuilding.CreateVBTitle.Text":"Virtual Buildings",
"virtualbuilding.btnCreateVirtualBuilding.Text":"Create Virtual Building",
"virtualbuilding.HeaderPopup.Text":"Enter Virtual Building Name",
"virtualbuilding.lblVirtualBuildingName.Text":"Name",
"virtualbuilding.DeviceName.Text":"Device Name",
"virtualbuilding.lblFilterHeader.Text":"Filters",
"virtualbuilding.Filter.lblAssignment.Text":"Assignments",
"virtualbuilding.Filter.chkAssigned.Text":"Assigned Objects",
"virtualbuilding.Filter.chkUnassigned.Text":"Unassigned Objects",
"virtualbuilding.Filter.Text":"Filter",
"virtualbuilding.Loading.Text":"Loading...",
"virtualbuilding.btnAssign.Text":"Assign to Virtual Buildings >",
"Create.VirtualBuildingName.Text":"Virtual Buildings",
"Assignvirtualbuilding.btnApply.Text":"Apply",
"Assignvirtualbuilding.btnClose.Text":"Close",
"virtualbuilding.DeletePopup.Text":"Delete Virtual Building",
"virtualbuilding.lblDeleteMessage.Text":"You have chosen to delete a virtual building. Do you want to continue?",
"virtualbuilding.btnSaveDel.Text":"Yes, Delete",
"virtualbuilding.DuplicateError.Text":"Error: Please specify a unique name for the Virtual building.",
"virtualbuilding.SelectVirtualBuildingError.Text":"Error: Please select at least one virtual building.",
"virtualbuilding.SelectObjectError.Text":"Error: Please select at least one object to assign to a virtual building.",
"virtualbuilding.BuildingNameError.Text":"Error: One or more of the virtual building names is blank or is not unique.",
"DomainExist.Text":"Domain value already exist",
"DomainValid.Text":"A valid domain is required",
"GridTextBox.Validation.Text":"Save or Cancel before proceeding",
"MailIDDomain.Validation.Text":"Email domain must match domain(s) specified on previous SAML Setup step",
"MailIDExist.Validation.Text":"Email address is already being used by existing user",

};
export default class Common {
	static FamilyList(value) {
		return resourceData[value];
	}
};